export const SET_FINANCIAL_PROFILE = "fprofile/SET_FINANCIAL_PROFILE";
export const SET_FINANCIAL_PROFILE_SUCCESS =
  "fprofile/SET_FINANCIAL_PROFILE_SUCCESS";
